import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import {urlBase} from "../../config/Globals";

const OtherArticles = ({articles,articleId,plus}) => {
    return (
        <section className="bg-gris py-lg-5">
            <div className="container px-4 py-5">
                <h2 className="display-6 fw-sb mb-5 text-center">Autres articles</h2>

                <div className="row g-5 justify-content-center">
                    <div className="col-12 col-lg-8 col-xxl-6">
                        <Swiper
                            modules={[Pagination]}
                            slidesPerView={1}
                            spaceBetween={30}
                            grabCursor={true}
                            pagination={{
                                clickable: true,
                                el: '.custom-swiper-pagination'
                            }}
                            className="mySwiper"
                        >
                            {articles &&
                                articles
                                    .filter((article) => article.id !== articleId)
                                    .map((article) => (
                                        <SwiperSlide key={article.id} className="d-flex">
                                            <div className="card border-0 rounded-0 w-100 bg-marron d-flex flex-column justify-content-between">
                                                <div className="text-center text-lg-start">
                                                    <div className="p-4 p-xl-5">
                                                        <h3 className="fw-sb text-white mb-3">{article.titre}</h3>
                                                    </div>
                                                </div>
                                                <div className="p-4 p-xl-5 pt-0 pt-xl-0 text-center text-lg-start">
                                                    <a
                                                        href={`${urlBase}tout-savoir-sur-la-flavescence-doree${plus == '1' ? '/plus' : ''}/${article.id_rubrique.wording}/${article.id}`}
                                                        className="btn btn-warning d-inline-block"
                                                    >
                                                        En savoir plus
                                                    </a>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))
                            }
                        </Swiper>
                        <div className="custom-swiper-pagination swiper-pagination mt-5 position-relative"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OtherArticles;